<script>
/* components */
import Terms from '@/blocks/Terms';
/* tools */
import {} from '@/scripts/utils';

export default {
  name: 'TermsView',
  components: {
    Terms,
  },
};
</script>

<template>
  <div class="root">
    <Terms />
  </div>
</template>

<style scoped lang="scss">
@import '@/styles/variables.scss';
.root {
  background-color: #aabbcc;
}
</style>
